import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { catchError, Observable, of } from 'rxjs';
import { PaginateQuery, PaginateResult } from '../core/models';

@Injectable({ providedIn: 'root' })
export class CustomerConversationService extends ApiService {
  constructor(http: HttpClient) {
    super(http, 'Customer');
  }

  public override paginate(data: PaginateQuery): Observable<PaginateResult> {
    return this.http.post<PaginateResult>(this.route() + '/paginateConversations', data).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of({ total: 0, list: [] });
        } else {
          throw error;
        }
      })
    );
  }

  public paginateFive9(data: PaginateQuery): Observable<PaginateResult> {
    return this.http.post<PaginateResult>(this.route() + '/PaginateConversationsFive9', data).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          return of({ total: 0, list: [] });
        } else {
          throw error;
        }
      })
    );
  }
}
